<template>
  <div> 
   <v-toolbar color="accent" dark="" flat=""> 
     <!-- <v-btn  to="/" icon=""  color="b1" class="pr-4"  ><v-icon size="25" >dashboard</v-icon></v-btn> -->
      <!-- <div class="font-weight-bold font-italic">Home / Page Link</div> -->
      <v-row class="b1--text not-shadow" >
        <div v-for="(link, index) in links" :key="index"> 
            <div class="not-f4 font-weight-bold font-italic white--text" v-if="not.size(links)===index+1">
              <div v-if="!$route.params.id">
                {{not.TEXT_UP11(link)}}
              </div>
              <div v-else>
                ...
              </div>
            </div>
            <router-link v-else :to="getLink({name:link,index:index})" class="not-f4 not-line0 font-italic b1--text">
              {{link===""?"Dashboard":not.TEXT_UP11(link)}}
              <span class="not-4 font-weight-bold px-1">/</span>
            </router-link> 
        </div>
              
      </v-row>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{not.TEXT_UP11($route.name)}}</v-toolbar-title> 
    </v-toolbar>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  props:["not"],
  data: () => ({
     
  }),
  computed: {
    phoneSize(){ 
      let  width = this.not.vs.width 
      if(width<1000){
        return true
      }else{
        return false
      }
    },
    us(){
      return this.not.us
    },
    links(){
      let path = this.$route.path
      return path.split("/")
    }
  },
  methods: {
    navOpen(){
      this.$emit("navOpen")
    },
    clicked(){},
     getLink(item){
      let index = item.index
      let name = item.name
      let path = this.$route.path
      let id = this.$route.path

      if (!index) {
        return "/"
      }
      if (index===0) {
        return "/"
      }else {
        let link = path.split(name)  
        return link[0]+name
      }
    }
  },
};
</script>
